import * as types from './mutation-types'
export default {
  [types.LOAD_QVCT_ANSWER_TYPE](state, data) {
    state.qvctAnswersType = data
  },

}
